export const companyInfo = {
  name: "NICHE Digital Marketing",
  logo: "https://customer-assets.emergentagent.com/job_68f291bd-ecea-49bf-9504-f0f563e60088/artifacts/qe8bz4h1_1.png",
  logoAlt: "NICHE Digital Marketing Logo",
  tagline: "Tailored digital marketing solutions that help businesses stand out, attract their ideal customers, and scale online.",
  objective: "To deliver a customized digital marketing strategy for Clients, focused on increasing brand awareness, engaging the right audience, and driving measurable results."
};

export const services = [
  {
    id: 'facebook-instagram',
    title: 'Facebook & Instagram Marketing',
    icon: 'Users',
    description: 'Facebook & Instagram Marketing is the process of using the two most popular social platforms to promote your business, connect with your target audience, and turn followers into loyal customers.',
    benefits: [
      'Strategic content planning and creation',
      'Targeted audience engagement',
      'Brand growth and lead generation',
      'Increased sales through social media'
    ],
    features: [
      'Branded Posts Creation',
      'Content Planning & Strategy', 
      'Caption Writing with Hashtags & CTA',
      'Media Buying & Advertisement',
      'Page Analysis & Optimization',
      'Performance Reporting',
      'Real-time Monitoring',
      'Growth Strategy Tips'
    ],
    pricing: [
      {
        name: 'STARTER BOOST',
        price: '6,500',
        currency: 'BAHT/MONTH',
        features: [
          '7 Branded Posts',
          'Content Planning & Strategy',
          'Caption Writing with Hashtags & CTA',
          'Media Buying',
          'Page Analysis',
          'Performance Report'
        ]
      },
      {
        name: 'SMART GROWTH',
        price: '9,500',
        currency: 'BAHT/MONTH',
        popular: true,
        features: [
          '10 Branded Posts',
          'Content Planning & Strategy',
          'Caption Writing with Hashtags & CTA',
          'Media Buying',
          'Page Optimization Recommendations',
          'Performance Report'
        ]
      },
      {
        name: 'BRAND POWER',
        price: '12,000',
        currency: 'BAHT/MONTH',
        features: [
          '15 Branded Posts',
          'Content Planning & Strategy',
          'Caption Writing with Hashtags & CTA',
          'Media Buying',
          'Real-time Monitoring',
          'Page Optimization Recommendations',
          'Performance Report',
          'Growth Strategy Tips'
        ]
      }
    ]
  },
  {
    id: 'tiktok',
    title: 'TikTok Marketing',
    icon: 'Video',
    description: 'TikTok Marketing is all about using short-form, entertaining, and engaging videos to reach your ideal audience and grow your brand fast. It\'s one of the most powerful platforms right now for visibility.',
    benefits: [
      'Viral trend research and creative planning',
      'Short-form video creation (15-60 seconds)',
      'Professional editing with effects and transitions',
      'Targeted TikTok advertising campaigns'
    ],
    features: [
      'Trend Research & Creative Planning',
      'Short-Form Video Creation',
      'Professional Video Editing',
      'TikTok Ads Management',
      'Caption Writing & Hashtag Strategy',
      'Performance Tracking & Analytics'
    ],
    pricing: [
      {
        name: 'STARTER BOOST',
        price: '6,500',
        currency: 'BAHT/MONTH',
        features: [
          '5 Short-Form Videos (15–30 sec)',
          'Trend Research & Concept Planning',
          'Script/Caption Writing + Hashtags',
          'Basic Editing & Visual Effects',
          'Posting Support & Caption Strategy',
          'Media buying (DOC)',
          'Performance Check-in'
        ]
      },
      {
        name: 'SMART GROWTH',
        price: '9,500',
        currency: 'BAHT/MONTH',
        popular: true,
        features: [
          '7 Short-Form Videos',
          'Trend Research + Visual Planning',
          'Script/Caption Writing + Hashtag Optimization',
          'Editing with Effects, Captions & Transitions',
          'Upload Scheduling + Timing Strategy',
          'Media buying (DOC)',
          'Monthly Performance Report'
        ]
      },
      {
        name: 'BRAND POWER',
        price: '12,000',
        currency: 'BAHT/MONTH',
        features: [
          '10 High-Impact TikTok Videos',
          'Trend Forecasting + Creative Direction',
          'Script, Caption & Hook Optimization',
          'Professional Editing',
          'Upload Scheduling + Timing & Sound Strategy',
          'Media buying (DOC)',
          'Monthly Report + Insights + Optimization Tips'
        ]
      }
    ]
  },
  {
    id: 'google-maps',
    title: 'Google & Google Maps Marketing',
    icon: 'Search',
    description: 'Google is the #1 place people go when they\'re ready to buy, search, or visit. Google Search Ads and Google Maps optimization ensure you show up first when customers are looking for you.',
    benefits: [
      'Keyword research and high-converting ad campaigns',
      'Google Business Profile optimization',
      'Search and Display ads management',
      'Local visibility and lead generation'
    ],
    features: [
      'Keyword Research & Campaign Setup',
      'Google Maps Optimization',
      'Search and Display Ads Management',
      'Budget Control and Bidding Strategy',
      'Review Strategy and Engagement',
      'Performance Reporting & Analytics'
    ],
    pricing: [
      {
        name: 'STARTER BOOST',
        price: '4,500',
        currency: 'BAHT/MONTH',
        features: [
          '1 Google Search Campaign',
          'Google Maps Listing Audit',
          'Basic Optimization',
          'Monthly Report'
        ]
      },
      {
        name: 'SMART GROWTH',
        price: '7,500',
        currency: 'BAHT/MONTH',
        popular: true,
        features: [
          '1 Search + 1 Display Campaign',
          'Full Google Maps Optimization',
          'Keyword Strategy',
          'Monthly Report + Recommendations'
        ]
      },
      {
        name: 'BRAND POWER',
        price: '10,000',
        currency: 'BAHT/MONTH',
        features: [
          'Advanced Search & Display Ads',
          'Google Maps Optimization + Review Strategy',
          'Conversion Tracking Setup',
          'Performance Report + Monthly Strategy Call'
        ]
      }
    ]
  },
  {
    id: 'website',
    title: 'Website Creation',
    icon: 'Globe',
    description: 'Website Creation is the process of building a professional, mobile-friendly, and SEO-ready website that represents your brand, informs your audience, and converts visitors into customers.',
    benefits: [
      'Custom design tailored to your brand identity',
      'Mobile-responsive and user-friendly design',
      'SEO optimization for better search visibility',
      'Integration with social media and business tools'
    ],
    features: [
      'Custom Design & Branding',
      'Mobile-Responsive Layout',
      'SEO Optimization',
      'Social Media Integration',
      'Contact Forms & Business Tools',
      'Hosting & Domain Setup'
    ],
    pricing: [
      {
        name: 'STARTER SITE',
        price: '10,000',
        currency: 'BAHT',
        features: [
          'Up to 3 pages (Home, About, Contact)',
          'Mobile-Responsive Design',
          'Basic SEO',
          'Contact Form',
          '1 Design Revision'
        ]
      },
      {
        name: 'STANDARD SITE',
        price: '15,000',
        currency: 'BAHT',
        popular: true,
        features: [
          'Up to 5 pages (Home, About, Services, Contact, Gallery)',
          'Custom Layout',
          'Google Maps & Social Integration',
          '2 Revisions'
        ]
      },
      {
        name: 'PREMIUM SITE',
        price: '22,000',
        currency: 'BAHT',
        features: [
          'Up to 8 pages + Blog or Booking Feature',
          'Advanced Design Elements',
          'Google Analytics Setup',
          'Speed Optimization',
          '3 Revisions'
        ]
      }
    ],
    addOns: [
      { name: 'E-commerce Setup', price: '9,000 BAHT' },
      { name: 'SEO Copywriting Services', price: '3,000 BAHT' },
      { name: 'Google Search Console + Analytics Integration', price: '3,000 BAHT' },
      { name: 'Monthly Website Maintenance', price: '2,000 BAHT' }
    ]
  }
];

export const workflow = [
  {
    step: 1,
    title: 'Client Brief',
    duration: '1 Day',
    description: 'We gather all necessary details about your business, goals, and audience.'
  },
  {
    step: 2,
    title: 'Brainstorming',
    duration: '2 Days',
    description: 'We analyze your requirements and develop creative strategies tailored to your needs.'
  },
  {
    step: 3,
    title: 'Content Planning',
    duration: '3 Days',
    description: 'We select post formats, write captions, and finalize visual directions.'
  },
  {
    step: 4,
    title: 'Content Calendar',
    duration: '1 Day',
    description: 'We organize all posts and campaigns into a structured monthly calendar.'
  },
  {
    step: 5,
    title: 'Confirmation',
    duration: '1 Day',
    description: 'You review and approve all planned content and schedules.'
  },
  {
    step: 6,
    title: 'Uploading',
    duration: '1 Day',
    description: 'We upload and schedule the content across selected platforms.'
  },
  {
    step: 7,
    title: 'Media Buying',
    duration: '1 Day',
    description: 'We launch ad campaigns and apply targeting & budget strategies.'
  },
  {
    step: 8,
    title: 'Reporting',
    duration: '3 Days',
    description: 'We analyze performance, generate reports, and provide optimization tips.'
  }
];

export const whyChooseUs = [
  {
    title: 'Platform Expertise',
    description: 'Expert knowledge across Facebook, Instagram, Google, TikTok, and web platforms',
    icon: 'Target'
  },
  {
    title: 'Trend-Aware Content',
    description: 'We stay ahead of the latest trends and algorithm changes to keep your content relevant',
    icon: 'TrendingUp'
  },
  {
    title: 'Transparent Reporting',
    description: 'Clear, detailed reports showing exactly how your campaigns are performing',
    icon: 'BarChart'
  },
  {
    title: 'Flexible Pricing',
    description: 'Multiple pricing tiers to fit businesses of all sizes and budgets',
    icon: 'DollarSign'
  },
  {
    title: 'Local Market Understanding',
    description: 'Deep understanding of the Thai market and local consumer behavior',
    icon: 'MapPin'
  }
];

export const contactInfo = {
  title: "Ready to Grow Your Business?",
  subtitle: "Let's discuss how we can help you achieve your digital marketing goals",
  cta: "Schedule a Free Consultation",
  email: "nichedigital.marketing9.0@gmail.com",
  phone: "+66 955 050 811",
  address: "Bangkok, Thailand",   // ✅ new
  social: {                      // ✅ optional social links
    facebook: "https://www.facebook.com/profile.php?id=61577090491731"
  }
};
